import React from 'react'
import { Box, Typography } from '@mui/material'
import { Fullscreen, FullscreenExit, Refresh } from '@mui/icons-material'
import IconButton from '@mui/material/IconButton'
import { formatDistance } from 'date-fns'
import PropTypes from 'prop-types'

const Toolbar = ({ lastUpdated, currentTime, updateInfoFn, isFullscreen, exitFn, enterFn }) => {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      padding: isFullscreen ? 0 : 1
    }}
    >
      <Typography sx={{ marginRight: 1 }}>
        {`Last updated: ${formatDistance(lastUpdated, currentTime, { addSuffix: true, includeSeconds: true })}`}
      </Typography>
      <IconButton onClick={updateInfoFn}>
        <Refresh />
      </IconButton>
      <IconButton onClick={isFullscreen ? exitFn : enterFn}>
        {isFullscreen ? <FullscreenExit /> : <Fullscreen />}
      </IconButton>
    </Box>
  )
}

Toolbar.propTypes = {
  lastUpdated: PropTypes.any,
  currentTime: PropTypes.any,
  updateInfoFn: PropTypes.func,
  isFullscreen: PropTypes.bool,
  exitFn: PropTypes.func,
  enterFn: PropTypes.func
}

export default Toolbar
